"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonProtonInvitationState = void 0;
var NonProtonInvitationState;
(function (NonProtonInvitationState) {
    NonProtonInvitationState["Pending"] = "pending";
    NonProtonInvitationState["UserRegistered"] = "userRegistered";
})(NonProtonInvitationState || (exports.NonProtonInvitationState = NonProtonInvitationState = {}));
//# sourceMappingURL=sharing.js.map